import { lazy, Suspense } from 'react'
import { Outlet } from 'react-router-dom'
// auth
import { AuthGuard, GuestGuard } from 'src/auth/guard'
// layouts
import DefaultLayout from 'src/layouts/default'
import LoginLayout from 'src/layouts/login/login'
// components
// import { SplashScreen } from 'src/components/loading-screen'
import { basicPaths } from '../basic-paths'

const DealerView = lazy(() => import('src/sections/dealer'))
const Login = lazy(() => import('src/pages/auth/login'))
const Auth = lazy(() => import('src/pages/auth/auth'))

const routes = basicPaths
  .map((route) =>
    route.paths.map((path) => ({
      path,
      element: <DealerView pageUrl={route.pageUrl} />,
    }))
  )
  .flat()

export const mainRoutes = [
  {
    path: 'app',
    element: (
      <AuthGuard>
        <DefaultLayout>
          <Suspense>
            <Outlet />
          </Suspense>
        </DefaultLayout>
      </AuthGuard>
    ),
    children: routes,
  },
  {
    path: 'login',
    element: (
      <GuestGuard>
        <LoginLayout>
          <Login />
        </LoginLayout>
      </GuestGuard>
    ),
  },
  {
    path: 'auth',
    element: (
      <GuestGuard>
        <LoginLayout>
          <Auth />
        </LoginLayout>
      </GuestGuard>
    ),
  },
]
